export default __webpack_public_path__ + "386519550ecdb315e3cf4780bf7c1ee6.png";